import BlockSwitcher from './BlockSwitcher';

export default BlockSwitcher;